<template>
  <div class="w-full h-full flex flex-col px-6 py-6 text-black">
    <h3 class="title">{{ titleText }}</h3>
    <div class="flex">
      <div class="grid">
        <p class="info" v-html="$t('stamp.clothes_info')"></p>
        <clothes small class="pr-4" />
        <p class="alt-info mt-4" v-html="altInfo"></p>
      </div>
      <div class="grid">
        <p class="info" v-html="$t('stamp.accessories_info')"></p>
        <accessories class="mt-4 lg:mt-12" />
      </div>
    </div>
  </div>
</template>

<script>
import incein from '@/mixins/incein';

import Clothes from './Clothes.vue';
import Accessories from './Accessories.vue';

export default {
  name: 'BeforeScan',
  components: {
    Clothes,
    Accessories,
  },
  mixins: [incein],
  computed: {
    titleText() {
      return this.isIncein
        ? this.$t('incein.things_to_note_title')
        : this.$t('stamp.things_to_note_title');
    },
    altInfo() {
      return this.isIncein ? this.$t('incein.clothes_alt_info') : this.$t('stamp.clothes_alt_info');
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  @apply mx-auto mt-6 mb-8;
  font-size: 20px;
}
.grid {
  @apply flex flex-col justify-between items-start w-1/2;
  & > div {
    height: 50%;
  }
  &:first-of-type {
    @apply pl-5 pr-2;
    border-right: 2px solid black;
    & > div {
      @apply my-6;
    }
  }
  &:last-of-type {
    @apply pl-8 pr-4;
    & > div {
      @apply mb-auto;
    }
  }
}
.info {
  @apply mb-5;
  font-size: 16px;
  @screen lg {
    font-size: 20px;
  }
}
.alt-info {
  font-size: 14px;
  @screen lg {
    font-size: 18px;
  }
}
</style>
